import { PropertyLead } from 'types/PropertyLead';
import { PropertyLeadsQuery } from 'types/PropertyLeadsQuery';
import { DEFAULT_REGION, Region } from 'types/Region';
import { create } from 'zustand';

interface State {
    propertyRequestQueryFilter: PropertyLeadsQuery;
    setPropertyRequestQueryFilter: (propertyRequestQueryFilter: PropertyLeadsQuery) => void;
    page: number;
    setPage: (page: number) => void;
    savedRequestsPage: number;
    setSavedRequestsPage: (page: number) => void;
    selectedLead: PropertyLead;
    setSelectedLead: (lead: PropertyLead) => void;
    localFilters: PropertyLeadsQuery;
    setLocalFilters: (filters: PropertyLeadsQuery) => void;
    region: Region;
    setRegion: (region: Region) => void;
    selectedFilter: string;
    setSelectedFilter: (filter: string) => void;
    savedFilters: Record<string, any>[];
    setSavedFilters: (filters: Record<string, any>[]) => void;
    selectedSortOption: string;
    setSelectedSortOption: (option: string) => void;
}

const usePropertyRequestsStore = create<State>((set) => ({
    propertyRequestQueryFilter: {
        isArchived: false,
    },
    setPropertyRequestQueryFilter: (data: PropertyLeadsQuery) =>
        set((state) => ({
            propertyRequestQueryFilter: Object.keys(data).length === 0 ? {} : { ...state.propertyRequestQueryFilter, ...data },
        })),
    page: 0,
    setPage: (page: number) => set({ page }),
    savedRequestsPage: 0,
    setSavedRequestsPage: (page: number) => set({ savedRequestsPage: page }),
    selectedLead: {} as PropertyLead,
    setSelectedLead: (lead: PropertyLead) => set({ selectedLead: lead }),
    localFilters: {},
    setLocalFilters: (filters: PropertyLeadsQuery) =>
        set((state) => ({
            localFilters: Object.keys(filters).length === 0 ? {} : { ...state.localFilters, ...filters },
        })),
    region: DEFAULT_REGION,
    setRegion: (region: Region) => set({ region }),
    selectedFilter: '',
    setSelectedFilter: (filter: string) => set({ selectedFilter: filter }),
    get savedFilters() {
        return JSON.parse(localStorage.getItem('savedPropertyRequestFilters') || '[]');
    },
    setSavedFilters: (filters) => {
        localStorage.setItem('savedPropertyRequestFilters', JSON.stringify(filters));
        set({ savedFilters: filters });
    },
    selectedSortOption: 'Latest',
    setSelectedSortOption: (option: string) => set({ selectedSortOption: option }),
}));

export default usePropertyRequestsStore;
